import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MaintenanceBanner } from './MaintenanceBanner';
import { DashboardHeader } from './DashboardHeader';
import { KnowledgeOverlay } from './KnowledgeOverlay';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';

interface LayoutProps {
  children: React.ReactNode;
  breadcrumb?: string;
  maxWidth?: 'sm' | 'md' | 'lg';
  showDashboardHeader?: boolean;
  showChatBot?: boolean;
  showResetButton?: boolean;
  showDashboardButton?: boolean;
  showSidebar?: boolean;
}

export function Layout({ children, breadcrumb, maxWidth = 'md', showDashboardHeader = false, showChatBot = false, showResetButton = true, showDashboardButton = false, showSidebar = false }: LayoutProps) {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const maxWidthClass = {
    sm: 'max-w-xl',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
  }[maxWidth];

  const handleSignOut = async () => {
    try {
      const { supabase } = await import('../lib/supabase');
      await supabase.auth.signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-[#F2F2EF]">
      {showSidebar && (
        <>
          <Sidebar onSignOut={handleSignOut} />
          <MobileNav
            isOpen={isMobileMenuOpen}
            onClose={() => setIsMobileMenuOpen(false)}
            onSignOut={handleSignOut}
          />
        </>
      )}

      <div className={showSidebar ? 'lg:pl-64' : ''}>
        {showDashboardHeader && (
          <div className="md:hidden">
            <DashboardHeader
              showResetButton={showResetButton}
              showDashboardButton={showDashboardButton}
              onMenuClick={showSidebar ? () => setIsMobileMenuOpen(true) : undefined}
            />
          </div>
        )}

        {breadcrumb && (
          <div className="sticky top-0 bg-white border-b border-gray-200 z-10">
            <div className={`mx-auto px-4 py-3 ${maxWidthClass}`}>
              <p className="text-sm text-gray-600 font-medium">{breadcrumb}</p>
            </div>
          </div>
        )}

        {!showDashboardHeader && <MaintenanceBanner />}

        <div className={`mx-auto px-4 py-8 md:pt-8 ${maxWidthClass}`}>
          {children}
        </div>
      </div>

      {showChatBot && <KnowledgeOverlay />}
    </div>
  );
}
